import { ANYTIME_PREFERENCE_VALUE } from 'constants/advancedSearch';
import { THEME } from 'GlobalStyles';
import strings from 'strings';

const { priorities: prioritiesValues } = strings.resumeSearch.filters;

export const priorities = [
  {
    id: 'must_have',
    label: prioritiesValues.mustHave,
    shortLabel: 'Must',
    color: THEME.palette.success.main
  },
  {
    id: 'can_have',
    label: prioritiesValues.canHave,
    shortLabel: 'Can',
    color: THEME.palette.primary.main
  },
  {
    id: 'doesnt_have',
    label: prioritiesValues.doesntHave,
    shortLabel: 'Not',
    color: THEME.palette.error.main
  }
];

export const PRIORITY_IDS = {
  MustHave: 'must_have',
  CanHave: 'can_have',
  DoesntHave: 'doesnt_have'
};

export const PRIORITY_CLASS_NAMES = {
  [PRIORITY_IDS.MustHave]: 'must-have',
  [PRIORITY_IDS.CanHave]: 'can-have',
  [PRIORITY_IDS.DoesntHave]: 'doesnt-have'
};

export const DEFAULT_PROPS = {
  defaultPriority: PRIORITY_IDS.MustHave,
  defaultPreference: ANYTIME_PREFERENCE_VALUE
};

export const POPOVER_CONFIG = {
  anchorOrigin: {
    horizontal: 'center',
    vertical: 'bottom'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center'
  }
};
